// extracted by mini-css-extract-plugin
export var content = "GetStartedModal-module--content--jO6C5";
export var footer = "GetStartedModal-module--footer--Enwb+";
export var header = "GetStartedModal-module--header--G0JNP";
export var notification = "GetStartedModal-module--notification--VrnF5";
export var progressBar = "GetStartedModal-module--progressBar--BGMjw";
export var rocketIcon = "GetStartedModal-module--rocketIcon--bHYcC";